import React from 'react'
import { hasAccessToThis } from 'services/Utilities'
import { t } from 'translations'

const UserSpecificRestrictions = ({ specificRestrictions, canBeNull }) => {
  if (!hasAccessToThis('userManageSpecificRestrictions')) return canBeNull ? t('components.MISSING_PERMISSIONS') : null
  if (!specificRestrictions.length) return canBeNull ? t('components.NO_SPECIFIC_RESTRICTIONS') : null

  return (
    <>
      {t(`manager.schedule.EDIT_MODAL.SPECIFIC_RESTRICTIONS`, {
        count: specificRestrictions.length,
        specificRestrictions: specificRestrictions.join(', ')
      })}
    </>
  )
}

export default UserSpecificRestrictions

UserSpecificRestrictions.defaultProps = {
  specificRestrictions: []
}
